import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/lib/api';
import type { DashboardMetrics } from '../types';

interface UseDashboardMetricsParams {
  month?: number;
  year?: number;
}

/**
 * Hook para buscar métricas do dashboard de Feedback e PDI
 */
export function useDashboardMetrics({ month, year }: UseDashboardMetricsParams = {}) {
  return useQuery({
    queryKey: ['feedback-pdi', 'dashboard', 'metrics', month, year],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (month) params.append('month', month.toString());
      if (year) params.append('year', year.toString());

      const response = await api.get<{ metrics: DashboardMetrics }>(
        `/feedback-pdi/dashboard/metrics?${params.toString()}`
      );

      return response.data.metrics;
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

// Outros hooks foram movidos para arquivos separados:
// - useCheckIns.ts
// - usePDIs.ts
// - useMicroFeedbacks.ts
// - usePreparationForms.ts
